var _classCallCheck = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/Arquisoft/viade_en1a/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

/**
 * Dependencies
 */

/**
 * FormUrlEncoded
 */
var FormUrlEncoded = /*#__PURE__*/function () {
  "use strict";

  function FormUrlEncoded() {
    _classCallCheck(this, FormUrlEncoded);
  }

  _createClass(FormUrlEncoded, null, [{
    key: "encode",

    /**
     * Encode
     *
     * @description
     * Represent an object as x-www-form-urlencoded string.
     *
     * @param {Object} data
     * @returns {string}
     */
    value: function encode(data) {
      var pairs = [];
      Object.keys(data).forEach(function (key) {
        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
      });
      return pairs.join('&');
    }
    /**
     * Decode
     *
     * @description
     * Parse a x-www-form-urlencoded into an object.
     *
     * @param {string} data
     * @returns {Object}
     */

  }, {
    key: "decode",
    value: function decode(data) {
      var obj = {};
      data.split('&').forEach(function (property) {
        var pair = property.split('=');
        var key = decodeURIComponent(pair[0]);
        var val = decodeURIComponent(pair[1]);
        obj[key] = val;
      });
      return obj;
    }
  }]);

  return FormUrlEncoded;
}();
/**
 * Export
 */


module.exports = FormUrlEncoded;